import React, { useState } from "react";
import {
  Col,
  Row,
  Typography,
  List,
  Form,
  Layout,
  Input,
  Button,
  Tabs, Image, Modal,
  Checkbox
} from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import {
  FaCheckCircle
} from "react-icons/fa";
import { ImageUrl } from "../../helpers/Functions";



const data6 = [
  {
    avatar: <FaCheckCircle />,
    title: "All Core Features",
  },
  {
    avatar: <FaCheckCircle />,
    title: "Build Custom features. Limits Apply",
  },
  {
    avatar: <FaCheckCircle />,
    title: "24-7 helpdesk support and Premium Customer Success team",
  },
];
const onChange = (key) => {
  console.log(key);
};




function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const items = [
    {
      key: "1",
      label: "Pricing For Cource",
      children: (
        <>
          <div className="price-flexbox">
            <div className="price-cards" style={{ minHeight: "473px" }}>
              <h4 className="text-38 text-white">Plan Name</h4>
              <h4 className="text-38 text-white">$ 35</h4>
              <p className="text-p-16 text-white">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor.
              </p>
              {/* <p className="text-p-16 text-white">Starts at $999/Month</p> */}
              <div className="list-box">
                <List
                  itemLayout="horizontal"
                  dataSource={data6}
                  renderItem={(item, index) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<span className="list-icon">{item.avatar}</span>}
                        title={<h6 className="list-h6">{item.title}</h6>}
                      />
                    </List.Item>
                  )}
                />
              </div>
              <Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={showModal}
                //   onClick={() => navigate("/about-us")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>
            </div>
            <div className="price-cards" style={{ minHeight: "473px" }}>
              <h4 className="text-38 text-white">Plan Name</h4>
              <h4 className="text-38 text-white">$ 50</h4>
              <p className="text-p-16 text-white">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor.
              </p>
              {/* <p className="text-p-16 text-white">Starts at $999/Month</p> */}
              <div className="list-box">
                <List
                  itemLayout="horizontal"
                  dataSource={data6}
                  renderItem={(item, index) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<span className="list-icon">{item.avatar}</span>}
                        title={<h6 className="list-h6">{item.title}</h6>}
                      />
                    </List.Item>
                  )}
                />
              </div>
              <Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={showModal}
                //   onClick={() => navigate("/about-us")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>
            </div>
            <div className="price-cards" style={{ minHeight: "473px" }}>
              <h4 className="text-38 text-white">Plan Name</h4>
              <h4 className="text-38 text-white">$ 50</h4>
              <p className="text-p-16 text-white">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor.
              </p>
              {/* <p className="text-p-16 text-white">Starts at $999/Month</p> */}
              <div className="list-box">
                <List
                  itemLayout="horizontal"
                  dataSource={data6}
                  renderItem={(item, index) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<span className="list-icon">{item.avatar}</span>}
                        title={<h6 className="list-h6">{item.title}</h6>}
                      />
                    </List.Item>
                  )}
                />
              </div>
              <Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={showModal}
                //   onClick={() => navigate("/about-us")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>
            </div>
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: "Price For enterprise",
      children: (
          <>
            <div className="price-flexbox">
              <div className="price-cards" style={{ minHeight: "473px" }}>
                <h4 className="text-38 text-white">Plan Name</h4>
                <h4 className="text-38 text-white">$ 35</h4>
                <p className="text-p-16 text-white">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                  commodo ligula eget dolor.
                </p>
                {/* <p className="text-p-16 text-white">Starts at $999/Month</p> */}
                <div className="list-box">
                  <List
                    itemLayout="horizontal"
                    dataSource={data6}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<span className="list-icon">{item.avatar}</span>}
                          title={<h6 className="list-h6">{item.title}</h6>}
                        />
                      </List.Item>
                    )}
                  />
                </div>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="whiteButton"
                  onClick={showModal}
                  //   onClick={() => navigate("/about-us")}
                  style={{ marginLeft: "5px" }}
                >
                  Get Started
                </Button>
              </div>
              <div className="price-cards" style={{ minHeight: "473px" }}>
                <h4 className="text-38 text-white">Plan Name</h4>
                <h4 className="text-38 text-white">$ 50</h4>
                <p className="text-p-16 text-white">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                  commodo ligula eget dolor.
                </p>
                {/* <p className="text-p-16 text-white">Starts at $999/Month</p> */}
                <div className="list-box">
                  <List
                    itemLayout="horizontal"
                    dataSource={data6}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<span className="list-icon">{item.avatar}</span>}
                          title={<h6 className="list-h6">{item.title}</h6>}
                        />
                      </List.Item>
                    )}
                  />
                </div>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="whiteButton"
                  onClick={showModal}
                  //   onClick={() => navigate("/about-us")}
                  style={{ marginLeft: "5px" }}
                >
                  Get Started
                </Button>
              </div>
              <div className="price-cards" style={{ minHeight: "473px" }}>
                <h4 className="text-38 text-white">Plan Name</h4>
                <h4 className="text-38 text-white">$ 50</h4>
                <p className="text-p-16 text-white">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                  commodo ligula eget dolor.
                </p>
                {/* <p className="text-p-16 text-white">Starts at $999/Month</p> */}
                <div className="list-box">
                  <List
                    itemLayout="horizontal"
                    dataSource={data6}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<span className="list-icon">{item.avatar}</span>}
                          title={<h6 className="list-h6">{item.title}</h6>}
                        />
                      </List.Item>
                    )}
                  />
                </div>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="whiteButton"
                  onClick={showModal}
                  //   onClick={() => navigate("/about-us")}
                  style={{ marginLeft: "5px" }}
                >
                  Get Started
                </Button>
              </div>
            </div>
          </>
        ),
    },
  ];

  

  // useEffect if user is already logged in
  React.useEffect(() => {
    if (user && token) {
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, token]);

  return (
    <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
      <Row
        className="blueBackground-old aboutbanner"
        style={{
          height: "55vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography.Title
          className="fontFamily1 aboutbanner-content"
          style={{ fontSize: "30px", color: "#000" }}
        >
          {<> Our Pricing Packages</>}
        </Typography.Title>
      </Row>
      <section className="bg-white top-bottom-padding">
        <Row
          justify={"center"}
          style={{ textAlign: "center", paddingBottom: "40px" }}
        >
          <Col xl={10} lg={12}>
            <Image
              preview={false}
              alt={"Failed to load image"}
              src={ImageUrl("miniImg4.png")}
            />
            <h4 className="text-38 ">Pricing Plans</h4>
            <p className="text-p-16 ">
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
              commodo ligula eget dolor.
            </p>
          </Col>
        </Row>

        <Row justify={"center"} style={{ padding: "10px 0", margin: "10px 0" }}>
          <Col lg={20}>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange}className="price-tabs" />
          </Col>
        </Row>




        <Modal className="price-form-modal" title="Custom Pricing Contact Form" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} okText="Yes" cancelButtonProps={{
          style: {
            border: "2px solid rgb(0, 167, 157)",
            color: "#000",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "rgb(0, 167, 157)",
            color: "#fff",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid rgb(0, 167, 157)",
          },
        }}>
        {/* <h4 class="text-38 ">Pricing Plans</h4> */}
        <p class="" style={{fontSize:"14px" , textAlign:"center"}}>Please fill out the form below and we will set up a time for a meeting to discuss your training requirements.</p>
        <Form layout="vertical" style={{padding:"20px 0"}}>
          <Form.Item label="First Name" name="firstName" rules={[{ required: true, message: 'Please enter your first name' }]}> 
            <Input placeholder="Enter first name" />
          </Form.Item>
          <Form.Item label="Last Name" name="lastName" rules={[{ required: true, message: 'Please enter your last name' }]}> 
            <Input placeholder="Enter last name" />
          </Form.Item>
          <Form.Item label="Email Address" name="email" rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}> 
            <Input placeholder="Enter email address" />
          </Form.Item>
          <Form.Item label="Organization" name="organization" rules={[{ required: true, message: 'Please enter your organization' }]}> 
            <Input placeholder="Enter organization name" />
          </Form.Item>
          <Form.Item label="Number of Users" name="numUsers" rules={[{ required: true, message: 'Please enter the number of users' }]}> 
            <Input placeholder="Enter number of users" type="number" />
          </Form.Item>
          <Form.Item name="customPlan" valuePropName="checked">
            <Checkbox>I need a customized plan</Checkbox>
          </Form.Item>
        </Form>
      </Modal>
      </section>
    </Layout>
  );
}

export default Homepage;
